var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{staticClass:"four-zero-four"},[_c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"has-text-centered"},[_c('h1',{staticClass:"title has-margin-bottom has-text-light"},[_vm._v(" 404 - You're Lost ")]),_c('p',[_vm._v("We can't find the page you requested.")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }